import request from "root/js/request";

export const getSharesTableWbExport = async ({ cabinet_id, shares_id, in_shares }) => {
  const response = await request({
    url: `/api/analytics/shares_table/wb/export/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
    params: {
      in_shares,
    },
  });

  return response.data;
};
